import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { Order } from '../../shared/classes/order';
import { Document } from '../../shared/classes/document';
import { DocumentType } from '../../shared/classes/document-type.enum';
import { MatDialogConfig } from '@angular/material/dialog';
import { LoadingPopupComponent } from '../loading-popup/loading-popup.component';
import { OrderService } from '../../shared/services/order/order.service';
import { AuthService } from '../../shared/services/auth.service';
import { finalize, map, tap } from 'rxjs';
import { IUpdateSubmittedOrder } from '../../shared/services/order/update-submitted-order';
import { Sites } from '../../shared/services/order/order';
import { FormsModule } from '@angular/forms';
import { IEmployee } from '../../shared/classes/IEmployee';

function mapEmployeeSiteToOrderSite(site: IEmployee['site']): Sites {
    switch (site) {
        case 'Flanders':
            return 'Flanders';
        case 'Swords':
            return 'Swords';
        case 'Llanberis':
            return 'Llanberis';
        case 'Las Angeles':
        case 'Los Angeles':
            return 'LasAngeles';
        default:
            throw new Error(`Unsupported site: ${site}`);
    }
}

@Component({
    selector: 'app-inspect',
    templateUrl: './inspect.component.html',
    styleUrls: ['./inspect.component.css'],
    standalone: true,
    imports: [FormsModule, MatDialogActions]
})
export class InspectComponent implements OnInit {
    selectedOrder: Order;
    site: Sites;
    user: IEmployee['user'] = null;

    /** documentTypes: all document types (is used by HTML template) */
    public documentTypes: string[] = Object.values(DocumentType);

    /**
     * Constructs a new popup displaying the selected order.
     */
    constructor(
        private dialogRef: MatDialogRef<InspectComponent>,
        @Inject(MAT_DIALOG_DATA) public orderID: string,
        private dialog: MatDialog,
        private orderService: OrderService,
        private authService: AuthService
    ) {}

    async downloadDocument(document: Document): Promise<void> {
        const promise = this.orderService.downloadDocument(document);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            promise,
            errormessage: 'Document not available.'
        };
        this.dialog.open(LoadingPopupComponent, dialogConfig);
    }

    async ngOnInit(): Promise<void> {
        const auth = this.authService.user();

        if (!auth) {
            this.dialogRef.close();
            return;
        }

        this.site = mapEmployeeSiteToOrderSite(auth.site);
        this.user = auth.user;
        console.log(this.site, this.user);

        this.orderService
            .getSubmittedOrder(this.orderID, this.site)
            .pipe(
                map((order) => {
                    order.documents = Document.jsonToDocuments(order.documents);
                    return order;
                })
            )
            .subscribe((order) => {
                this.selectedOrder = order;
            });
    }

    /**
     * Close the popup and take no action on the order.
     */
    cancel(): void {
        this.dialogRef.close();
    }

    getPO(site: string): string {
        switch (site) {
            case 'Flanders':
                return this.selectedOrder.FlandersPO;
            case 'Swords':
                return this.selectedOrder.SwordsPO;
            case 'Llanberis':
                return this.selectedOrder.LlanberisPO;
            case 'LasAngeles':
            case 'Las Angeles':
                return this.selectedOrder.LasAngelesPO;
        }
    }

    async submit(): Promise<void> {
        const updateSubmittedOrderDTO: IUpdateSubmittedOrder = {
            id: this.selectedOrder.inspectorID,
            site: this.site,
            user: this.user,
            status: this.selectedOrder.inspectorStatus ?? '',
            comment: this.selectedOrder.inspectorComment ?? ''
        };
        this.orderService
            .updateSubmittedOrder(updateSubmittedOrderDTO)
            .pipe(
                tap({
                    next: () => {
                        window.location.reload();
                    },
                    error: (err) => {
                        console.error('Error updating order:', err);
                    }
                }),
                finalize(() => {
                    this.dialogRef.close();
                })
            )
            .subscribe();
    }
}
